{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "ดาวโหลด",
      "UPLOADING": "กำลังอัพโหลด"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "ส่ง"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "ส่งข้อความอีกครั้ง",
      "ERROR_MESSAGE": "ไม่สามารถส่งได้ ลองอีกครั้ง"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "เรากำลังออนไลน์",
    "OFFLINE": "เราไม่อยู่",
    "BACK_AS_SOON_AS_POSSIBLE": "We will be back as soon as possible"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "ปกติจะตอบกลับภายในไม่กี่นาที",
    "IN_A_FEW_HOURS": "ปกติจะตอบกลับในไม่กี่ชั่วโมง",
    "IN_A_DAY": "ปกติจะตอบกลับภายใน 1 วัน",
    "BACK_IN_HOURS": "We will be back online in {n} hour | We will be back online in {n} hours",
    "BACK_IN_MINUTES": "We will be back online in {time} minutes",
    "BACK_AT_TIME": "We will be back online at {time}",
    "BACK_ON_DAY": "We will be back online on {day}",
    "BACK_TOMORROW": "We will be back online tomorrow",
    "BACK_IN_SOME_TIME": "We will be back online in some time"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "START_CONVERSATION": "เริ่มการสนทนา",
  "END_CONVERSATION": "จบการสนทนา",
  "CONTINUE_CONVERSATION": "สนทนาต่อ",
  "YOU": "You",
  "START_NEW_CONVERSATION": "เริ่มการสนทนาใหม่",
  "VIEW_UNREAD_MESSAGES": "You have unread messages",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "ดูข้อความใหม่",
    "CLOSE_MESSAGES_BUTTON": "ปิด",
    "COMPANY_FROM": "จาก",
    "BOT": "บอท"
  },
  "BUBBLE": {
    "LABEL": "คุยกับเรา"
  },
  "POWERED_BY": "Powered by Chatwoot",
  "EMAIL_PLACEHOLDER": "กรุณากรอกอีเมล์ของคุณ",
  "CHAT_PLACEHOLDER": "พิมพ์ข้อความ",
  "TODAY": "วันนี้",
  "YESTERDAY": "เมื่อวาน",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "ชื่อเต็ม",
        "PLACEHOLDER": "โปรดใส่ชื่อเต็มของคุณ",
        "REQUIRED_ERROR": "จำเป็นต้องใส่ชื่อเต็ม"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "ที่อยู่อีเมล์",
        "PLACEHOLDER": "โปรดใส่อีเมล์ของคุณ",
        "REQUIRED_ERROR": "Email Address is required",
        "VALID_ERROR": "กรุณากรอกที่อยู่อีเมล์ให้ถูกต้อง"
      },
      "PHONE_NUMBER": {
        "LABEL": "หมายเลขโทรศัพท์",
        "PLACEHOLDER": "Please enter your phone number",
        "REQUIRED_ERROR": "Phone Number is required",
        "DIAL_CODE_VALID_ERROR": "Please select a country code",
        "VALID_ERROR": "Please enter a valid phone number",
        "DROPDOWN_EMPTY": "No results found",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "ข้อความ",
        "PLACEHOLDER": "โปรดพิมพ์ข้อความ",
        "ERROR": "ข้อความสั้นเกินไป"
      }
    },
    "CAMPAIGN_HEADER": "โปรดแจ้งชื่อ และ อีเมลื ก่อนเริ่มการสนทนา",
    "IS_REQUIRED": "is required",
    "REQUIRED": "โปรดระบุ",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "ไฟล์ใหเกินกว่า {MAXIMUM_FILE_UPLOAD_SIZE} ที่กำหนดไว้",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Invalid field"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Search emojis",
    "NOT_FOUND": "No emoji match your search",
    "ARIA_LABEL": "Emoji picker"
  },
  "CSAT": {
    "TITLE": "ให้คะแนนการสนทนาครั้งนี้",
    "SUBMITTED_TITLE": "ขอบคุณที่ร่วมมือให้คะแนนการสนทนากับเรา",
    "PLACEHOLDER": "บอกเราเพิ่มเติม..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "ต้องการให้ส่งบทสนทนานี้ทางอีเมล์",
    "SEND_EMAIL_SUCCESS": "บันทึกการสนทนาได้ถูกส่งเเล้ว",
    "SEND_EMAIL_ERROR": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Click here to join",
      "LEAVE_THE_ROOM": "Leave the call"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popular Articles",
    "VIEW_ALL_ARTICLES": "View all articles",
    "IFRAME_LOAD_ERROR": "There was an error loading the article, please refresh the page and try again."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "ข้อความภาพ"
    },
    "audio": {
      "CONTENT": "ข้อความเสียง"
    },
    "video": {
      "CONTENT": "ข้อความวิดิโอ"
    },
    "file": {
      "CONTENT": "เเนบไฟล์"
    },
    "location": {
      "CONTENT": "สถานที่"
    },
    "fallback": {
      "CONTENT": "ได้เเชร์ลิ้ง"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Replying to:"
  }
}
